import {
  IThreeLayerID,
  IR2PathsWithScript,
  IEntityBase,
  IMetadata,
  IScriptParams,
  IActionJavaData,
  IActionWebConfig
} from '../types/base';
import { IOwnership } from '../types/ownership';
import { IVisibilityChild } from '../types/visibility';
import { IFork } from '../types/fork';
import { IVersionLeaf } from '../types/version';
import { IPermissionData, IInjectConfig } from '../types/permission';
import { ulid } from 'ulid';
import { createMergeToDefaultData } from '../utils/mergeToDefaultData';

/**
 * 动作接口（泛型版本）
 * 对应SQL表：project_action
 * 对应Go结构：ProjectAction
 */
export interface IAction<
  TJavaData extends IActionJavaData = IActionJavaData,
  TWebConfig extends IActionWebConfig = IActionWebConfig
> extends
  IThreeLayerID,
  IEntityBase,
  IR2PathsWithScript,
  IOwnership,
  IVisibilityChild,
  IFork,
  IVersionLeaf,
  IMetadata,
  IScriptParams<TJavaData, TWebConfig>
{
  type: string;                      // 动作类型（如：tap, swipe, type等）
  permissions?: IPermissionData[];    // 权限列表
  injects?: IInjectConfig[];          // 注入配置列表
}

// 向后兼容的默认类型
export type IActionDefault = IAction<IActionJavaData, IActionWebConfig>;

// === 类型常量 ===
export const actionType = 'action'

// === Action Utils ===
function createDefaultAction(): IAction {
  return {
    ulid: ulid(),
    uuid: '',
    ownerUuid: '',
    currentVersion: 1,
    type: '',
    createdAt: Date.now(),
    updatedAt: Date.now(),
    authorUuid: ''
  } as IAction
}

export interface IActionBaseUtils {
  type: string
  createDefaultData: () => IAction
  mergeDataToDefaultData: (data: Partial<IAction>) => IAction
}

export const actionBaseUtils: IActionBaseUtils = {
  type: actionType,
  createDefaultData: createDefaultAction,
  mergeDataToDefaultData: createMergeToDefaultData(createDefaultAction)
}
